


<div class="ui modal" id="PrintLastPayout_Modal" style="width:274px; font-family:'Arial Narrow'">
    <div class="checkpanel" style="width: 95%; margin-left:14px;height:180px;background:white;">

        <div>
            <form>

                    <div style="min-height:20px;">
                        <div style="text-align:center">
                           <span> {{"PayoutSlip" | t}}</span>
                        </div>

                    </div>
                    <!--Period-->
                    <div *ngIf="this.tournamentsService.printLastPayout_List[0]?.IsPaid==false">
                        <div style="min-height:20px;">
                            <div class="payout_Window_Item">
                                <span style="font-weight:bold">{{"PaidStatus" | t}}:</span><span> {{this.tournamentsService.printLastPayout_List[0]?.IsPaid}}</span>
                            </div>

                        </div>
                        <div style="min-height:20px;">
                            <div class="payout_Window_Item">
                                <span style="font-weight:bold">{{"Amount" | t}}:</span><span>{{this.tournamentsService.printLastPayout_List[0]?.Amount}}</span>
                            </div>

                        </div>
                    </div>
                    <div *ngIf="this.tournamentsService.printLastPayout_List[0]?.IsPaid==true">

                        <div style="min-height:20px;">
                            <div class="payout_Window_Item">
                                <span style="font-weight:bold">{{"PaidStatus" | t}}:</span><span>{{this.tournamentsService.printLastPayout_List[0]?.IsPaid}}</span>
                            </div>

                        </div>
                        <div style="min-height:20px;">
                            <div class="payout_Window_Item">
                                <span style="font-weight:bold">{{"Amount" | t}}:</span><span>{{this.tournamentsService.printLastPayout_List[0]?.Amount}}</span>
                            </div>

                        </div>
                        <div style="min-height:20px;">
                            <div class="payout_Window_Item">
                                <span style="font-weight:bold">{{"UpdateDate" | t}}:</span><span>{{this.tournamentsService.printLastPayout_List[0]?.UpdateDate}}</span>
                            </div>

                        </div>
                        <div style="min-height:20px;">
                            <div class="payout_Window_Item">
                                <span style="font-weight:bold">{{"UpdateUserName" | t}}:</span><span>{{this.tournamentsService.printLastPayout_List[0]?.UpdateUserName}}</span>
                            </div>

                        </div>
                    </div>


            </form>


        </div>

    </div>

</div>
<div id="LastPayoutControlModal" class="ui modal">

    <div class="content">
        <span style="font-weight:bold;font-size:18px">{{"Coupons_Didnt_Found" | t}}!!!</span>
        <button class="circular ui icon button" style="float:right;position:relative;bottom:10px;background-color:white;border: 1px solid;" (click)="LastPayoutControlModal_Button_No()">
            <i class="remove link icon"></i>
        </button>
    </div>

</div>
